module.exports = __webpack_public_path__ + "icons/original/small/small-a1.7ec6461d1c92b8cd2af53465e9b35cfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-a1.png
// module id = qpPT
// module chunks = app